/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { Component, createRef } from 'inferno';
// COMPONENTS
import Checkbox from 'components/shared/checkbox/checkbox';
import CTAs from 'components/shared/ctas/ctas';
import Submit from 'components/shared/submit/submit';
import ValidationScreen from 'components/screens/validation/validation_container';

// UTILS
import { pageurl } from 'utils/environment';
import { isValidEmail } from 'utils/emailvalidation';
import { pxToEm } from 'utils/styles';
import { trackEvent } from 'utils/tracking/tracking';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/userdatacollection/phases/udcentry/udcentry_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, { link:false });


/* ========== ~~~~~~~~~~ SER DATA COLLECTION SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class UDCEntryPhase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: { value: null, valid: true },
            insticator: { value: false, valid: null },
            publisher: { value: false, valid: null }
        };
        this.headerTextRef = createRef();
        this.headerTitleRef = createRef();
    }

    componentDidMount() {
        this.handleDynamicFontSizeAdjustment();
        this.trackUDCEvent({ type: 'load', name: 'ceuContentLoad', target: 'udc' })
    }

    componentWillUnmount() {
        this.props.showLoader(false);
    }

    handleSubmit = () => {
        const checkboxesValid = this.state.insticator.value && this.state.publisher.value;
        const emailValid = isValidEmail(this.state.email.value);
        return checkboxesValid && emailValid ? this.processUDCDataSubmission() :
            this.processInvalidatedData(checkboxesValid, emailValid, false)
    };

    processUDCDataSubmission = () => {
        this.props.showLoader(true);
        this.props.submitUDCData(this.props.contentId, this.getUDCData('RESPONDED'), this.props.isPubPortalPreview, this.processUDCResponse)
    };

    processInvalidatedData = (checkboxesValid, emailValid, duplicateEmail) => {
        this.setState({
            email: { value: this.state.email.value, valid: emailValid && !duplicateEmail },
            insticator: { value: this.state.insticator.value, valid: !!this.state.insticator.value },
            publisher: { value: this.state.publisher.value, valid: !!this.state.publisher.value }
        });
        this.triggerValidationScren(checkboxesValid, emailValid, duplicateEmail)
    };

    processUDCResponse = response => {
        this.props.showLoader(false);
        if(!response.validRequest && !!response.reason &&  response.reason ==="Duplicated email") this.processDuplicateEmail()
        const type = response.validRequest ? 'success' : 'error';
        this.trackUDCEvent({ type, name: 'ceuContentEngaged', target: 'udc' })
    };

    processDuplicateEmail = () => {
        this.triggerValidationScren(true, true, true);
        this.setState({
            email: { value: this.state.email.value, valid: false },
        });
    };

    triggerValidationScren = (checkboxesValid, emailValid, duplicateEmail) => {
        this.props.displayScreen({
            name: 'validation',
            type: 'full',
            visible: true,
            content: <ValidationScreen
                contentId={this.props.contentId}
                checkboxes={!checkboxesValid}
                email={!emailValid}
                duplicate={duplicateEmail}
            />
        })
    };

    getUDCData = (engagementType) => {
        const { userId, embedUUID, udcId, contentSignature, city, country } = this.props;
        return {
            cookieId: userId,
            contentUUID: udcId,
            contentType: 'user_data_collection',
            pageUrl: pageurl,
            embedUUID,
            contentSignature,
            contentProperties: {
                engagementType,
                ...(engagementType === 'RESPONDED' && { email: this.state.email.value, city, country })
            }
        }
    };

    handleCheckboxChange = property =>
        this.setState({ [property]: { value: !this.state[property].value, valid: null } });

    handleEmailInput = (e) => this.setState({ email: {value: e.target.value, valid: null }});

    getPolicyText = ({ key, name, link }) =>
        <span className={'textlabel'}>
            {`Agree to `}
            <a onClick={() => this.trackPolicyClick(key)} target={'_blank'} href={link}>{`the ${name} Privacy Policy`}</a>
        </span>;

    trackUDCEvent = ({ type, name, target }) => {
        const { udcId, publisherName } = this.props;
        trackEvent({ type, name, additionalProps: { udcId, publisherName }, target });
    };

    trackPolicyClick = target => this.trackUDCEvent({ type: 'click', name: 'ceuClicks', target: `${target}Policy` });

    handleDynamicFontSizeAdjustment = () => {
        const headerTextEl = this.headerTextRef.current;
        const titleEl = this.headerTitleRef.current;
        if (headerTextEl !== null && titleEl !== null) {
            if (headerTextEl.clientHeight === 0 || headerTextEl.clientWidth === 0) return;
            const isOverflown = (element) => element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
            let fontSizePercentage = 100;
            const adjustFontSize = () => {
                if (isOverflown(headerTextEl)) {
                    console.log('overflowing text');
                    titleEl.setAttribute('style', `font-size:${--fontSizePercentage}%;`);
                    adjustFontSize(); // call function recursively until the font is sized properly
                } else {
                    return; // now that we have a font size that doesn't overflow the container breakout of the function
                }
            };
            adjustFontSize();
        }
    };

    render() {
        return (
            <div className={`${sheet.classes.udcentryphase} uniquecontent ${this.props.phase}`}>
                <div className={'headertext'} ref={this.headerTextRef}>
                    <h2 className={'title'} ref={this.headerTitleRef}><span className={'titletext'}>{this.props.headline}</span></h2>
                    <p className={'desc'}>{this.props.body}</p>
                </div>
                <p className={'label'}>Your email</p>
                <div className={`field isValid-${this.state.email.valid}`}>
                    <input
                        id={this.props.contentId}
                        className={`input isValid-${this.state.email.valid}`}
                        placeholder={`ex: i@mail.com`}
                        value={this.state.email.value}
                        onKeyUp={null}
                        onInput={this.handleEmailInput}
                        disabled={false}/>
                </div>
                <div className={`checkboxgroup`}>
                    <Checkbox
                        key={'insticator'}
                        text={this.getPolicyText({
                            key: 'insticator',
                            name: 'Insticator',
                            link: 'https://www.insticator.com/privacy/'
                        })}
                        valid={this.state.insticator.valid === null ? true : this.state.insticator.valid}
                        checked={this.state.insticator.value}
                        disabled={false}
                        onChange={() => this.handleCheckboxChange('insticator')}
                    />
                    <Checkbox
                        key={'publisher'}
                        text={this.getPolicyText({
                            key: 'publisher',
                            name: this.props.publisherName,
                            link: this.props.publisherPrivacyPolicyURL
                        })}
                        valid={this.state.publisher.valid === null ? true : this.state.publisher.valid}
                        checked={this.state.publisher.value}
                        disabled={false}
                        onChange={() => this.handleCheckboxChange('publisher')}
                    />
                </div>
                <CTAs type={`inline`}>
                    <Submit onSubmit={this.handleSubmit} disabled={false}/>
                </CTAs>
            </div>
        );
    }

}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UDCEntryPhase;
